module.exports = __webpack_public_path__ + "assets/trash-icon.183b0c21.svg";